import '../styles/footer.css'
import footerLogo from '../../assets/icons/footerlogo.svg'
import PurpleBtn from '../UI/PurpleBtn'
import facebookIcon from '../../assets/icons/facebook.svg'
import twitterIcon from '../../assets/icons/twitter.svg'
import linkdIcon from '../../assets/icons/linkd.svg'
import { Link } from 'react-router-dom'

export default function Footer() {

  const faqHandler = () => {
    window.scroll(0,0)
  }

  return (
    <footer className='footer'>
      <div className="container">
        <div className='footer__logo'>
          <Link to={'/'}>
            <img src={footerLogo} alt="footer-logo" />
          </Link>
        </div>
        <div className='footer__colum first'>
          <div className='footer__subtitle'>
            Navigation
          </div>
          <ul className='footer__list'>
            <li className='footer__link'>
              <a href="/">Home</a>
            </li>
            <li className='footer__link'>
              <a href="/">Features</a>
            </li>
            <li className='footer__link'>
              <a href="/">Extension</a>
            </li>
            <li className='footer__link'>
              <a href="/">Pricing</a>
            </li>
            <li className='footer__link'>
              <a href="/">contact us</a>
            </li>
          </ul>
        </div>
        <div className='footer__colum second'>
          <div className='footer__subtitle'>
          Resources
          </div>
          <ul className='footer__list'>
            <li className='footer__link'>
              <Link onClick={faqHandler } to="/faq">FAQ</Link>
            </li>
            <li className='footer__link'>
              <a href="/">BLOG</a>
            </li>
            <li className='footer__link'>
              <a href="/">docs</a>
            </li>
          </ul>
        </div>
        <div className='footer__colum third'>
          <div className='footer__subtitle'>
          App
          </div>
          <ul className='footer__list'>
            <li className='footer__link'>
              <a href="/">resume builder</a>
            </li>
            <li className='footer__link'>
              <a href="/">dashboard</a>
            </li>
            <li className='footer__link'>
              <a href="/">targeted resume</a>
            </li>
            <li className='footer__link'>
              <a href="/">review a resume</a>
            </li>
            <li className='footer__link'>
              <a href="/">get premium</a>
            </li>
          </ul>
        </div>
        <div className="footer__form">
          <div className='footer__subtitle form-subtitle'>
            Newsletter
          </div>
          <div className='footer__text'>
            Subscribe to our newsletter to keep up 
            to date on our marketing, website, design services, and tips.
          </div>
          <form className='footer__inputs'>
            <input 
            placeholder='Enter email' 
            className='footer__input' 
            type="text"
            />
            <PurpleBtn text='Submit'/>
          </form>
          <div className='footer__text small'>
          We hate spam as much as you do. We will never, ever send you such emails. 
          </div>
        </div>
      </div>
      <hr className='footer__line'/>
      <div className="footer__row">
        <div className='footer__rights'>
        © {new Date().getFullYear()} RESUME RAISE.
         All Rights Reserved
        </div>
        <div className='social-media'>
            <a className='social-media__item' href="/" target={'_blank'}>
              <img src={facebookIcon} alt={'facebook'}/>
            </a>
            <a className='social-media__item' href="/" target={'_blank'}>
              <img src={twitterIcon} alt={'twitter'}/>
            </a>
            <a className='social-media__item' href="/" target={'_blank'}>
              <img src={linkdIcon} alt={'linkedIn'}/>
            </a>
        </div>
      </div>
    </footer>
  )
}
